import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import incomeService from "../Services/incomeService";
import Loading from "../Modals/Loading";
import { FaArrowLeft } from "react-icons/fa6";
import DeleteModal from "../Components/DeleteModal";
import { HiOutlineTrash } from "react-icons/hi";
import Head from "../Components/Head";

const Income = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [deleteID, setDeleteID] = useState();
  const [deleting, setDeleting] = useState(false);
  const [open, setOpen] = useState(false);
  const [trigger, setTrigger] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [totalIncome, setTotalIncome] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const initiateDelete = (id) => {
    setOpen(!open);
    setDeleteID(id);
  };

  useEffect(() => {
    incomeService
      .fetchAllBySpecificDate({
        startDate: startDate ? startDate : null,
        endDate: endDate ? endDate : null,
      })
      .then((res) => {
        setFilteredData(res.incomes);
        const totalAmount = res.incomes.reduce(
          (total, item) => total + item.amount,
          0
        );
        setTotalIncome(totalAmount);
      });
  }, [startDate, endDate]);

  const handleDelete = () => {
    setDeleting(true);
    incomeService.delete(deleteID).then((res) => {
      setDeleting(false);
      setTrigger(!trigger);
    });
  };

  useEffect(() => {
    setLoading(true);
    incomeService.fetchAllIncomes().then((res) => {
      setData(res.incomes);
      setFilteredData(res.incomes);
      const totalAmount = res.incomes.reduce(
        (total, item) => total + item.amount,
        0
      );
      setTotalIncome(totalAmount);
      setLoading(false);
    });
  }, [trigger]);

  const filtered = filteredData.filter((income) =>
    income.company_name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalFilteredIncome = filtered.reduce(
    (acc, item) => acc + item.amount,
    0
  );

  return (
    <div className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg mb-20 bg-white">
      <DeleteModal
        open={open}
        setOpen={setOpen}
        deleteFunction={handleDelete}
        deleting={deleting}
      />
      {loading ? (
        <Loading />
      ) : (
        <div>
          <Head
            heading={"Customer Payments"}
            button_text={"Add Customer Payments"}
            navigation={() => navigate("/incomes/add")}
          />
          <div className="mt-4">
            <div className="flex gap-6">
              <div className="flex flex-col">
                <label className="primary-label">Search</label>
                <input
                  type="text"
                  placeholder="Search Here..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="primary-input !w-80"
                />
              </div>
              <div className="flex flex-col">
                <label className="primary-label">Start Date</label>
                <input
                  type="date"
                  name="from"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  className="primary-input"
                />
              </div>
              <div className="flex flex-col">
                <label className="primary-label">End Date</label>
                <input
                  type="date"
                  name="from"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  className="primary-input"
                />
              </div>
            </div>
          </div>
          <div className="table-div">
            <table>
              <thead>
                <tr className="border-y-2 text-left w-full text-black text-[10px]">
                  <th className="w-[1%] py-4 pl-4">Sr No.</th>
                  <th className="w-[2%] py-4 pl-4">Date</th>
                  <th className="w-[2%] py-4">Voucher Id</th>
                  <th className="w-[6%] py-4">Customer</th>
                  <th className="w-[2%] py-4 ">Account</th>
                  <th className="w-[2%] py-4">Amount</th>
                  <th className="w-[6%] py-4">Notes</th>
                  <th className="w-[1%] py-4">Delete</th>
                </tr>
              </thead>
              <tbody>
                {filteredData
                  ?.filter((income) =>
                    income?.company_name
                      ?.toLowerCase()
                      .includes(searchTerm.toLowerCase())
                  )
                  .map((income, index) => (
                    <tr
                      key={index}
                      className="bg-accent border-b border-gray-100 text-left"
                    >
                      <td className=" py-4 w-[1%] pl-4 font-bold text-blue-500">
                        {index + 1}.
                      </td>
                      <td className=" py-4 w-[2%] pl-4 font-semibold">
                        {income.date}
                      </td>
                      <td className=" py-4 w-[2%] ">{income.voucher}</td>
                      <td className=" py-2 w-[6%] font-bold pr-3">
                        {income.company_name}
                      </td>
                      <td className=" py-4 w-[2%]">{income.account}</td>
                      <td className=" py-4 w-[2%] ">{income.amount} AED</td>
                      <td className="w-[6%] text-[10px] font-bold text-gray-600">
                        {income.note}
                      </td>
                      <td className="py-4 w-[1%]">
                        <button
                          onClick={() => initiateDelete(income.id)}
                          className="px-4"
                        >
                          <HiOutlineTrash className="h-4 w-4 text-red-500" />
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <div className="font-bold text-gray-500 text-lg">
            Total Income during the selected period :{" "}
            <span className="text-teal-600">{totalFilteredIncome}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default Income;
